import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingService } from '../core/services/onboarding.service';

@Component({
  selector: 'sp-onboarding',
  standalone: true,
  imports: [
    MatDialogModule,
    MatStepperModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    TranslateModule,
  ],
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent {
  private readonly dialogRef = inject(MatDialogRef<OnboardingComponent>);
  private readonly onboardingService = inject(OnboardingService);

  finishOnboarding(): void {
    this.onboardingService.markOnboardingAsCompleted();
    this.dialogRef.close();
  }

  skipOnboarding(): void {
    this.onboardingService.markOnboardingAsCompleted();
    this.dialogRef.close();
  }
} 